export default "__VITE_PUBLIC_ASSET__19f9f46f__"